<div ngForm="form" class="d-flex flex-column h-100">
	@if (value) {
		<div class="flex-grow-1">
			<div layout="row" class="margin-bottom-15">
				<vb-ui-form-group flex="100">
					<label for="eLinkName" #uiLabel>{{ 'Event_Link_Name' | translate }}</label>
					<input type="text" name="eLinkName" class="form-control input-with-icon" [placeholder]="'Event_Link_Name' | translate " [attr.aria-label]="'Event_Link_Name' | translate " [(ngModel)]="value.name" (ngModelChange)="onNameChange()" #eLinkName="ngModel" trim="blur" uiControl vbRequired vbUiTextInput/>
					@if (eLinkName.touched && eLinkName.invalid) {
						<div role="alert" vbUiErrorMessage uiValidation>
							@if (eLinkName.errors.required) {
								{{ 'ThisFieldIsRequired' | translate }}
							} @else if (eLinkName.errors.duplicateName) {
								{{ 'Event_Embed_Content_Duplicate' | translate }}
							}
						</div>
					}
				</vb-ui-form-group>
			</div>

			<div layout="row" class="margin-bottom-15">
				<vb-ui-form-group flex="100">
					<label for="eLinkCode" #uiLabel>
						{{ 'Event_Link_Code' | translate }}
						<vb-ui-tooltip [iconName]="'circle_question_mark'" [placement]="'right'" [text]="'Event_Tab_Icon_Select_Code_Tooltip' | translate">
						</vb-ui-tooltip>
					</label>
					<textarea type="text" class="form-control text-area" name="eLinkCode" [placeholder]="'Event_Link_Code' | translate" [attr.aria-label]="'Event_Link_Code' | translate" [(ngModel)]="value.code" [ngModelOptions]="{ updateOn: 'blur' }" (ngModelChange)="validateCode()" #eLinkCode="ngModel" rows="4" trim="blur" uiControl vbRequired vbUiTextInput>
					</textarea>
					@if (eLinkCode.touched && eLinkCode.invalid) {
						<div role="alert" vbUiErrorMessage uiValidation>
							@if (eLinkCode.errors.required) {
								{{ 'ThisFieldIsRequired' | translate }}
							} @else if (eLinkCode.errors.invalidCode) {
								{{ 'Event_Link_Code_Invalid' | translate}}
							}
						</div>
					}
				</vb-ui-form-group>
			</div>

			<div layout="row" class="margin-bottom-15">
				<vb-ui-form-group>
					<label for="eLinkIcon" #uiLabel>
						{{ 'Event_Tab_Icon' | translate }}
						<vb-ui-tooltip [iconName]="'circle_question_mark'" [placement]="'right'" [text]="'Event_Tab_Icon_Select_Tooltip' | translate">
						</vb-ui-tooltip>
					</label>
					<vb-ng-select-wrap uiControl>
						<ng-select name="eLinkIcon" theme="bootstrap" labelForId="eLinkIcon" class="select-tab-icon" [title]="'Event_Tab_Icon' | translate" [(ngModel)]="value.icon" (ngModelChange)="onIconChange()" #selectWrap="ngModel" required>
							<ng-option [value]="''">
								<span>{{'Event_Tab_Icon_Select' | translate}}</span>
							</ng-option>
							<ng-option *ngFor="let icon of iconList" [value]="icon">
								<span [ngClass]="'vb-icon vb-icon-center vb-icon-' + icon"></span>
							</ng-option>
						</ng-select>
					</vb-ng-select-wrap>
					@if (selectWrap.touched && selectWrap.invalid) {
						<div role="alert" vbUiErrorMessage uiValidation>
							@if (selectWrap.errors.required) {
								{{ 'ThisFieldIsRequired' | translate }}
							}
						</div>
					}
				</vb-ui-form-group>
			</div>
		</div>

		<div layout="row" class="margin-bottom-15 mt-auto" flex-justify="end">
			@if (isSidebar) {
				<button type="button" (click)="onCancelClick()" vbBtnSecondary>{{ 'Cancel' | translate }}</button>
			} @else {
				<button type="button" (click)="onCancelClick()" vbBtnWhite>{{ 'Cancel' | translate }}</button>
			}
			
			<button type="button" class="margin-left-5" vbBtnPrimary [disabled]="form.invalid || isCodeValidating" (click)="onSubmit()">{{ (isEditMode ? 'Update' : 'Add') | translate }}</button>
		</div>
	}
</div>
